import { render, staticRenderFns } from "./NewCommerce.vue?vue&type=template&id=758d59b1&"
import script from "./NewCommerce.vue?vue&type=script&lang=ts&"
export * from "./NewCommerce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports